import { useCallback, useEffect, useState } from 'react';
import { initReactI18next, useTranslation } from 'react-i18next';
import { configuredLanguage, initI18next as init, onLanguageChange, setLanguage } from '@sas/nova-core/i18n';
import i18n from 'i18next';
export { configuredLanguage, getLanguage, getTextLocalizer, _getTextLocalizer, loadBundle, onLanguageChange, setLanguage } from '@sas/nova-core/i18n';
/**
 * Initialize i18next with a backend. Needs to be called once during application startup.
 * @param backends An array of i18next backends to be used with the chained backend.
 * @param backendOptions An i18next options array for the backends
 * @param initialLanguage A BCP-47 locale that will be used as the initial language. This will override any user preferences.
 */
export function initI18next(backends, backendOptions, initialLanguage) {
  return init({
    backends,
    backendOptions,
    initialLanguage,
    modules: [initReactI18next]
  });
}

/**
 * Returns a function that will provide localized messages for a given key and optional parameter object.
 * Note: All message keys in Viya 4+ require the name of the bundle prefixed to the logical key. This function
 * will prepend the bundle name so users only need to provide the logical name.
 *
 * @param bundleName The name of the bundle you need to access
 */
export const useTextLocalizer = bundleName => {
  const {
    t
  } = useTranslation(bundleName);
  return useCallback((key, params) => t(`${bundleName}:${bundleName}.${key}`, params), [t, bundleName]);
};

/**
 * Returns a function that can be used to change the language of the application.
 */
export const useLanguageSetter = () => {
  return setLanguage;
};

/**
 * A re-export for useLangaugeSetter. Please use useLanguageSetter instead.
 * @deprecated
 */
export const useLocaleSetter = useLanguageSetter;

/**
 * Sets a handler for when the language changes.
 * @param onChange Handler function to be called when the language changes.
 */
export const useOnLanguageChange = onChange => {
  useEffect(() => onLanguageChange(onChange), [onChange]);
};
export const useLanguage = () => {
  const [lang, setLang] = useState(i18n.language ?? configuredLanguage);
  useOnLanguageChange(setLang);
  return lang;
};
export default useTextLocalizer;
//# sourceMappingURL=useTextLocalizer.js.map